import { Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import SimpleSnackbar from "../../components/controls/ToastMessage";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import SwapCallsIcon from "@mui/icons-material/SwapCalls";

const useStyles = makeStyles({
  greenMark: {
    color: "green",
    fontWeight: "800",
  },
  redMark: {
    color: "red",
    fontWeight: "600",
  },
  roletype: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
    marginTop: "20px !important",
    whiteSpace: "nowrap",
  },
  roletypeTop: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
    whiteSpace: "nowrap",
  },
  roletype1: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    color: " #2f2f2f",
    paddingTop: "5px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  roleTypeWithIcon: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
    marginTop: "20px !important",
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "left",
    gap: "5px",
  },
  ContentCopyIcon: {
    fontSize: "large !important",
    cursor: "pointer",
    "&:hover": {
      color: "#000",
    },
  },
  caption: {
    fontFamily: "Roboto !important",
    // fontStyle: "normal",
    // fontWeight: "500 !important",
    // fontSize: "14px !important",
    // lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
    marginTop: "20px !important",
    whiteSpace: "nowrap",
  },
});

const SessionTracking = (props) => {
  const { sessionData } = props;
  const classes = useStyles();

  const [latitudeInfo, setLatitudeInfo] = useState(null);
  const [longitudeInfo, setLongitudeInfo] = useState(null);
  const [open, setOpen] = useState(false);
  const [snacktext, setsnacktext] = useState("");

  useEffect(() => {
    if (sessionData?.geoInfo?.latitude) {
      const latitude = sessionData.geoInfo.latitude;
      const direction = latitude >= 0 ? "N" : "S";
      setLatitudeInfo(`${Math.abs(latitude.toFixed(3))}° ${direction}`);
    } else if (sessionData?.deviceMetadata?.ipMetaData?.latitude) {
      const latitude = sessionData.deviceMetadata.ipMetaData.latitude;
      const direction = latitude >= 0 ? "N" : "S";
      setLatitudeInfo(`${Math.abs(latitude.toFixed(3))}° ${direction}`);
    } else {
      setLatitudeInfo("N/A");
    }

    if (sessionData?.geoInfo?.longitude) {
      const longitude = sessionData.geoInfo.longitude;
      const direction = longitude >= 0 ? "E" : "W";
      setLongitudeInfo(`${Math.abs(longitude.toFixed(3))}° ${direction}`);
    } else if (sessionData?.deviceMetadata?.ipMetaData?.longitude) {
      const longitude = sessionData.deviceMetadata.ipMetaData.longitude;
      const direction = longitude >= 0 ? "E" : "W";
      setLongitudeInfo(`${Math.abs(longitude.toFixed(3))}° ${direction}`);
    } else {
      setLongitudeInfo("N/A");
    }
  }, [sessionData]);

  const handleCopyIP = () => {
    const ipAddress = sessionData?.deviceMetadata?.ipAddress || sessionData?.deviceMetadata?.ipMetaData?.ipAddress;
    navigator.clipboard.writeText(ipAddress);
    setOpen(true);
    setsnacktext("IP address copied.");
  };

  const handleCopyLocation = () => {
    const location =
      sessionData?.geoInfo?.externalSourceInfo?.place_name || sessionData?.deviceMetadata?.ipMetaData?.cityName;
    navigator.clipboard.writeText(location);
    setOpen(true);
    setsnacktext("Location copied.");
  };

  return (
    <Grid>
      <Grid container>
        <Grid item xs={6}>
          <Grid container direction="column">
            <Typography className={classes.roletypeTop}>Session Start</Typography>
            {/* <Typography className={classes.roletype1}>{sessionData?.sessionStart}</Typography> */}
            <Typography className={classes.roletype1}>
              {moment(sessionData?.sessionStartUtc).format("hh:mm:ss A MMM DD, YYYY")}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={5.5}>
          <Grid container direction="column">
            <Typography className={classes.roletypeTop}>Session End</Typography>
            {/* <Typography className={classes.roletype1}>{sessionData?.sessionEnd}</Typography> */}
            <Typography className={classes.roletype1}>
              {moment(sessionData?.sessionEndUtc).format("hh:mm:ss A MMM DD, YYYY")}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="column">
            <Typography className={classes.roleTypeWithIcon}>
              IP Address{" "}
              <Tooltip title="Copy IP address">
                <ContentCopyIcon className={classes.ContentCopyIcon} onClick={handleCopyIP} />
              </Tooltip>
              {sessionData?.deviceMetadata?.ipMetaData?.isProxy && (
                <Tooltip title="Indicates that the internet connection is going through some sort of intermediary, which could be a proxy server or a VPN.">
                  <SwapCallsIcon className={classes.ContentCopyIcon} />
                </Tooltip>
              )}
            </Typography>
            <Tooltip
              title={sessionData?.deviceMetadata?.ipAddress || sessionData?.deviceMetadata?.ipMetaData?.ipAddress}
            >
              <Typography className={classes.roletype1}>
                {sessionData?.deviceMetadata?.ipAddress || sessionData?.deviceMetadata?.ipMetaData?.ipAddress}{" "}
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={5.5}>
          <Grid container direction="column">
            <Typography className={classes.roletype}>Permissions</Typography>
            <Typography className={classes.roletype1}>
              Mic{" "}
              {sessionData?.deviceMetadata?.micPermission ? (
                <span className={classes.greenMark}>✓</span>
              ) : (
                <span className={classes.redMark}>❌</span>
              )}{" "}
              Camera{" "}
              {sessionData?.deviceMetadata?.cameraPermission ? (
                <span className={classes.greenMark}>✓</span>
              ) : (
                <span className={classes.redMark}>❌</span>
              )}{" "}
              Location{" "}
              {sessionData?.deviceMetadata?.geoLocationPermission ? (
                <span className={classes.greenMark}>✓</span>
              ) : (
                <span className={classes.redMark}>❌</span>
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container direction="column">
            <Typography className={classes.roletype}>OS</Typography>
            <Typography className={classes.roletype1}>{sessionData?.deviceMetadata?.platform}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container direction="column">
            <Typography className={classes.roletype}>Browser</Typography>
            <Tooltip title={`${sessionData?.deviceMetadata?.browser} ${sessionData?.deviceMetadata?.browserVersion}`}>
              <Typography className={classes.roletype1}>
                {sessionData?.deviceMetadata?.browser} {sessionData?.deviceMetadata?.browserVersion}
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={2.5}>
          <Grid container direction="column">
            <Typography className={classes.roletype}>Screen Width</Typography>
            <Typography className={classes.roletype1}>
              {sessionData?.deviceMetadata?.browserScreenWidth}px (
              {Math.abs(
                (sessionData?.deviceMetadata?.browserScreenWidth / sessionData?.deviceMetadata?.viewWidth) * 100
              ).toFixed(2)}
              %)
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={2.5}>
          <Grid container direction="column">
            <Typography className={classes.roletype}>Screen Height</Typography>
            <Typography className={classes.roletype1}>
              {sessionData?.deviceMetadata?.browserScreenHeight}px (
              {Math.abs(
                (sessionData?.deviceMetadata?.browserScreenHeight / sessionData?.deviceMetadata?.viewHeight) * 100
              ).toFixed(2)}
              %)
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container direction="column">
            <Typography className={classes.roletype}>Latitude</Typography>
            <Typography className={classes.roletype1}>{latitudeInfo}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container direction="column">
            <Typography className={classes.roletype}>Longitude</Typography>
            <Typography className={classes.roletype1}>{longitudeInfo}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={5.5}>
          <Grid container direction="column">
            <Typography className={classes.roleTypeWithIcon}>
              Location{" "}
              <Tooltip title="Copy location">
                <ContentCopyIcon className={classes.ContentCopyIcon} onClick={handleCopyLocation} />
              </Tooltip>
            </Typography>

            <Tooltip
              title={
                sessionData?.geoInfo?.placeName ||
                sessionData?.geoInfo?.externalSourceInfo?.place_name ||
                sessionData?.deviceMetadata?.ipMetaData?.cityName ||
                "--"
              }
            >
              <Typography className={classes.roletype1}>
                {sessionData?.geoInfo?.placeName ||
                  sessionData?.geoInfo?.externalSourceInfo?.place_name ||
                  sessionData?.deviceMetadata?.ipMetaData?.cityName}
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
        {sessionData?.geoInfo?.isGeoInfoFormIpMetadata &&
          sessionData?.geoInfo?.latitude &&
          sessionData?.geoInfo?.longitude && (
            <Grid item xs={12} sx={{ mt: 2, textAlign: "right" }}>
              <Typography variant="caption" className={classes.caption}>
                Coordinates and Location based on IP.
              </Typography>
            </Grid>
          )}
      </Grid>
      <SimpleSnackbar open={open} setOpen={setOpen} text={snacktext} />
    </Grid>
  );
};

export default SessionTracking;
